var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-box clearfix",style:(_vm.s)},[_c('body-left'),_c('body-right')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }